
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Chat/Chat.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Chat.html');
        
        var script = require('./Chat.ts').default;
        module.exports = require('./Chat.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    